import { Link } from "react-router-dom"
import {Calculator, Mail, Phone, MapPin} from 'lucide-react'

export default function Footer() {
  return (
    <footer className="bg-[#060E1A] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2.5">
              <div className="w-9 h-9 rounded-lg bg-emerald-500/10 flex items-center justify-center border border-emerald-500/20">
                <Calculator className="w-5 h-5 text-emerald-400" />
              </div>
              <div className="flex flex-col">
                <span className="text-white font-bold text-sm leading-tight">Restaurant Loan</span>
                <span className="text-emerald-400 text-[10px] font-semibold uppercase tracking-widest">Calculator</span>
              </div>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              Precision restaurant loan calculators for every business type. Get accurate monthly payment estimates for your culinary dream.
            </p>
          </div>

          {/* Calculators */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Calculators</h4>
            <ul className="space-y-3">
              <li><Link to="/franchise-financing" className="text-slate-400 text-sm hover:text-emerald-400 transition-colors">Franchise Financing</Link></li>
              <li><Link to="/sba-loans" className="text-slate-400 text-sm hover:text-emerald-400 transition-colors">SBA Loan Calculator</Link></li>
              <li><Link to="/bar-financing" className="text-slate-400 text-sm hover:text-emerald-400 transition-colors">Bar Financing</Link></li>
              <li><Link to="/startup-guide" className="text-slate-400 text-sm hover:text-emerald-400 transition-colors">Startup Guide</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Resources</h4>
            <ul className="space-y-3">
              <li><Link to="/franchise-financing" className="text-slate-400 text-sm hover:text-emerald-400 transition-colors">Subway Franchise Loans</Link></li>
              <li><Link to="/franchise-financing" className="text-slate-400 text-sm hover:text-emerald-400 transition-colors">McDonald's Franchise Loans</Link></li>
              <li><Link to="/sba-loans" className="text-slate-400 text-sm hover:text-emerald-400 transition-colors">Government Restaurant Loans</Link></li>
              <li><Link to="/bar-financing" className="text-slate-400 text-sm hover:text-emerald-400 transition-colors">SBA Loans for Bars</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <Mail className="w-4 h-4 text-emerald-400 flex-shrink-0" />
                info@restaurantloancalculator.com
              </li>
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <Phone className="w-4 h-4 text-emerald-400 flex-shrink-0" />
                (800) 555-LOAN
              </li>
              <li className="flex items-start gap-2 text-slate-400 text-sm">
                <MapPin className="w-4 h-4 text-emerald-400 flex-shrink-0 mt-0.5" />
                Nationwide Coverage, United States
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-xs">
            &copy; {new Date().getFullYear()} Restaurant Loan Hub. All rights reserved. For informational purposes only.
          </p>
          <p className="text-slate-600 text-xs">
            Calculator estimates are for educational purposes and do not constitute financial advice.
          </p>
        </div>
      </div>
    </footer>
  )
}
